var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55468 12.6328C2.70976 12.6328 2.35702 11.5473 3.04335 11.0469L13.4859 3.45079C13.6351 3.34153 13.8151 3.28262 14 3.28262C14.1849 3.28262 14.3649 3.34153 14.5141 3.45079L24.9566 11.0469C25.643 11.5445 25.2902 12.6328 24.4426 12.6328H22.75V22.8594H24.7187C24.8391 22.8594 24.9375 22.9578 24.9375 23.0781V24.5C24.9375 24.6203 24.8391 24.7188 24.7187 24.7188H3.28124C3.16093 24.7188 3.06249 24.6203 3.06249 24.5V23.0781C3.06249 22.9578 3.16093 22.8594 3.28124 22.8594H5.24999V12.6328H3.55468ZM14 5.37852L6.5871 10.7707H21.4129L14 5.37852ZM20.7812 12.6328H17.582V22.8594H20.7812V12.6328ZM15.6133 12.6328H12.4141V22.8594H15.6133V12.6328ZM7.21874 22.8594H10.4453V12.6328H7.21874V22.8594Z",
    fill: "#09321C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.44d96e98613c9c38baf3158852202639.svg";
export { ForwardRef as ReactComponent };